<template>

<component :is="(route) ? 'router-link' : 'div'" :to="routeTo" class="button" :data-theme="theme" :class="{'is-disabled': isDisabled, 'is-icon': icon, 'has-subtext': subtext, 'is-loading': isLoading}">

    <div class="button-text">

        {{ text }}
        <span v-if="icon" v-html="icon" />

        <div class="button-subtext" v-if="subtext">{{ subtext }}</div>
    
    </div>

</component>

</template>

<script>

export default {

    props: ['text', 'subtext', 'icon', 'route', 'params', 'id', 'theme', 'isDisabled', 'isLoading'],

    computed: {
    
        routeTo: function() {
        
            return (this.route) ? {
                name: this.route,
                params: (this.params) ? this.params : {
                    id: this.id
                }
            } : false
        
        }
    
    }

}

</script>

<style scoped>

.button {
    background-color: #005EB8;
    color: #fff;
    cursor: pointer;
    text-align: center;
    user-select: none;
    display: block;
}

.button.is-loading {
    pointer-events: none;
}

.button.is-disabled {
    pointer-events: none;
    opacity: 0.25;
}

.button[data-theme="white"] {
    background-color: #fff;
    color: #425563;
}

.button[data-theme="red"] {
    background-color: #cc5a5a;
    color: #fff;
}

.button[data-theme="green"] {
    background-color: #40b067;
    color: #fff;
}

.button[data-theme="grey"] {
    background-color: #768692;
    color: #fff;
}

td .button {
    height: 24px;
    padding: 0px 5px;
    line-height: 24px;
    font-size: 14px;
    border-radius: 12px;
    box-shadow: 0px 2px 2px #00000029;
}

td .button.has-subtext {
    height: 40px;
}

.button.is-icon {
    line-height: 40px;
    font-size: 16px;
    font-weight: 500;
}

.actions .button {
    margin-left: 20px;
    height: 52px;
    border-radius: 50px;
    box-shadow: 0px 3px 3px #00000029;
    font-size: 16px;
    font-weight: 500;
    padding: 0px 36px;
    line-height: 52px;
}

.button:hover {
    background-color: #044b8f;
    color: #fff;
}

.button[data-theme="white"]:hover {
    background-color: #b8b8b8;
    color: #425563;
}

.button[data-theme="red"]:hover {
    background-color: #ac4747;
    color: #fff;
}

.button[data-theme="grey"]:hover {
    background-color: #5b6973;
    color: #fff;
}

.button.is-loading .button-text {
    visibility: hidden;
}

.button-subtext {
    line-height: 14px;
    font-size: 12px;
    margin-top: -4px;
}

</style>
